var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 169,
    viewBox: "0 0 195 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H31.651L66.6806 82.4717L31.651 168H1L31.651 82.4717L1 1Z",
    fill: "url(#paint0_radial_54_340)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6387 1H93.2897L128.319 82.4717L93.2897 168H62.6387L93.2897 82.4717L62.6387 1Z",
    fill: "url(#paint1_radial_54_340)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.319 1H158.97L194 82.4717L158.97 168H128.319L158.97 82.4717L128.319 1Z",
    fill: "url(#paint2_radial_54_340)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H31.651L66.6806 82.4717L31.651 168H1L31.651 82.4717L1 1Z",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6387 1H93.2897L128.319 82.4717L93.2897 168H62.6387L93.2897 82.4717L62.6387 1Z",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.319 1H158.97L194 82.4717L158.97 168H128.319L158.97 82.4717L128.319 1Z",
    stroke: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_54_340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.5 84.5) rotate(90) scale(83.5 96.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.509615,
    stopColor: "#50DEDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7768EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_54_340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.5 84.5) rotate(90) scale(83.5 96.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.509615,
    stopColor: "#50DEDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7768EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_54_340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.5 84.5) rotate(90) scale(83.5 96.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.509615,
    stopColor: "#50DEDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7768EB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.167a1e999aa55549374d73dd58e73688.svg";
export { ForwardRef as ReactComponent };